import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { dailyreportDetails } from "../../../core/data/json/dailyreportDetails";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  fetchAllDailyReport,
  fetchAllDailyCount,
  fetchAllDailyAttendanceMonthly,
} from "../../../core/data/redux/reports/daily_report/daily.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { formatDate } from "../../../core/utils/FormatData";

 interface DailyProps {
  showOnlyTable?: boolean;
}
const DailyReport: React.FC<DailyProps> = ({showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedYear, setSelectedYear] = useState("2025");
  const [dailycount, setdailycount] = useState<any>(null);
  const [monthlycount, setmonthlycount] = useState<any>(null);
  const [tableKey, setTableKey] = useState(0);
  const [listdata, setlistdata] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchAllDailyReport()).then((res) => {
      setlistdata(res.payload.data);
    });
    dispatch(fetchAllDailyCount()).then((res) => {
      setdailycount(res.payload.data);
    });
  }, []);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, listdata]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllDailyAttendanceMonthly(selectedYear))
        .then((res) => {
          setmonthlycount(res.payload.data);
        })
        .catch((err: any) => {
          console.error("Failed to fetch payslip data:", err);
        });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const data = listdata ? listdata : [];
  const columns = [
    {
      title: "Name",
      dataIndex: "employee_name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link
                        to="#"
                        className="avatar avatar-md"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#view_details"
                    >
                        <ImageWithBasePath
                            src={`assets/img/users/${record.Image}`}
                            className="img-fluid rounded-circle"
                            alt="img"
                        />
                    </Link> */}
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#view_details"
              >
                {record.employee_name}
              </Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.length - b.employee_name.length,
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text: string) => {
        if (!text) return "-";
        const date = new Date(text);
        date.setDate(date.getDate());
        return formatDate(date);
      },
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.date).getTime();
        const dateB = new Date(b.date).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Punch In",
      dataIndex: "PunchIn",
      render: (value: string) => {
        const time = new Date(value).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
        return <span>{time}</span>;
      },
      sorter: (a: any, b: any) => new Date(a.PunchIn).getTime() - new Date(b.PunchIn).getTime(),
    },
    {
      title: "Punch Out",
      dataIndex: "PunchOut",
      render: (value: string) => {
        const time = new Date(value).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
        return <span>{time}</span>;
      },
      sorter: (a: any, b: any) => new Date(a.PunchOut).getTime() - new Date(b.PunchOut).getTime(),
    },
    {
      title: "Department",
      dataIndex: "department_name",
      sorter: (a: any, b: any) =>
        a.department_name.length - b.department_name.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: String, record: any) => (
        <span
          className={`badge  d-inline-flex align-items-center badge-xs ${text === "Present" ? "badge-soft-success" : "badge-soft-danger"
            }`}
        >
          <i className="ti ti-point-filled me-1"></i>
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
  ];

  useEffect(() => {
    const presentPerMonth = new Array(12).fill(0);
    const absentPerMonth = new Array(12).fill(0);

    if (monthlycount && monthlycount.length > 0) {
      monthlycount.forEach(({ month, present_count, absent_count }: any) => {
        const monthIndex = month - 1;
        presentPerMonth[monthIndex] = present_count;
        absentPerMonth[monthIndex] = absent_count;
      });
    }

    setdailychart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: presentPerMonth,
        },
        {
          ...prev.series[1],
          data: absentPerMonth,
        },
      ],
    }));
  }, [monthlycount]);

  //New Chart
  const [dailychart, setdailychart] = useState<any>({
    series: [
      { name: "Present", data: new Array(12).fill(0) },
      { name: "Absent", data: new Array(12).fill(0) },
    ],
    chart: {
      height: 130,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    colors: ["#4CAF50", "#F44336"],
  });


     if (showOnlyTable) {
  return (
 <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={data}
                columns={columns}
                Selection={false}
              />
            </div>
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Daily Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Daily Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data, "Daily_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data, "Daily_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-12 d-flex">
              <div className="row flex-fill">
                {/* Total Companies */}
                <div className="col-lg-3 col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Present
                          </p>
                          <h4>{dailycount?.[0].present_count}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-primary bg-transparent-primary rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-user-check text-primary" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Total Companies */}
                <div className="col-lg-3 col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Completed Tasks
                          </p>
                          <h4>{dailycount?.[0].completed_count}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-success bg-transparent-success rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-subtask text-success" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Inactive Companies */}
                <div className="col-lg-3 col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Absent
                          </p>
                          <h4>{dailycount?.[0].absent_count}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-danger bg-transparent-danger rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-user-x text-danger" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Pending Tasks
                          </p>
                          <h4>{dailycount?.[0].pending_count}</h4>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-skyblue bg-transparent-skyblue rounded-circle d-flex align-items-center justify-content-center">
                              <i className="ti ti-user-x text-skyblue" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Inactive Companies */}
                {/* Company Location */}
                <div className="col-lg-2 col-md-2 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="fs-12 fw-normal mb-1 text-truncate">Open Tickets</p>
                      <h4>{dailycount?.[0].open_count}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="fs-12 fw-normal mb-1 text-truncate">Closed Tickets</p>
                      <h4>{dailycount?.[0].closed_count}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="fs-12 fw-normal mb-1 text-truncate">Pending Expenses</p>
                      <h4>{dailycount?.[0].pending_expense_count}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="fs-12 fw-normal mb-1 text-truncate">Approved Expenses</p>
                      <h4>{dailycount?.[0].approved_expense_count}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="fs-12 fw-normal mb-1 text-truncate">Pending Timesheet</p>
                      <h4>{dailycount?.[0].pending_timesheet_count}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="fs-12 fw-normal mb-1 text-truncate">Approved Timesheet</p>
                      <h4>{dailycount?.[0].approved_timesheet_count}</h4>
                    </div>
                  </div>
                </div>
                {/* /Company Location */}
              </div>
            </div>
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-bar text-danger" />
                      </span>
                      <h5>Daily Attendance</h5>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="d-inline-flex align-items-center me-2 mb-0">
                        <i className="ti ti-square-filled fs-12 text-success me-2" />
                        Present
                      </p>
                      <p className="d-inline-flex align-items-center mb-0 me-2">
                        <i className="ti ti-square-filled fs-12 text-danger me-2" />
                        Absent
                      </p>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="payslip-chart"
                    options={dailychart}
                    series={dailychart.series}
                    type="line"
                    height={130}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Daily Attendance List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        Select Status
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Present
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Absent
                                            </Link>
                                        </li>
                                    </ul>
                                </div> */}
                {/* <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        Sort By : Last 7 Days
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Desending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div> */}
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={data}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default DailyReport;
